__webpack_require__.p = "/kendo-react-ui/components/";